import {Nav} from "../../../common/nav";
import {resolve} from "../../../container";
import {customElement, property} from "lit/decorators.js";
import {UnLitElement} from "../../../common/elements";
import {clickEventAlreadyHandledByChild, MOUSE_BUTTON} from "../../../common/utils/events";

@customElement("eop-background-link")
export class EopBackgroundLink extends UnLitElement {
    @property({attribute: "href"})
    public href: string;
    @property({attribute: "target"})
    public target: string;

    public constructor(private nav: Nav = resolve(Nav)) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();

        if (!this.href || this.href.length === 0) {
            return;
        }

        this.style.cursor = "pointer";
        this.setAttribute("tabindex", "0");
        this.setAttribute("role", "link");

        this.addEventListener("mousedown", (event) => {
            if (event.button === MOUSE_BUTTON.MIDDLE) {
                event.preventDefault(); // prevent autoscroll by middle mouse button
            }
        });

        this.addEventListener("click", (event) => {
            if (clickEventAlreadyHandledByChild(event, this)) {
                return;
            }

            if (event.ctrlKey) {
                this.navigateNewWindow();
            } else {
                this.navigate();
            }
        });

        this.addEventListener("auxclick", (event) => {
            if (clickEventAlreadyHandledByChild(event, this)) {
                return;
            }

            if (event.button === MOUSE_BUTTON.MIDDLE) {
                this.navigateNewWindow();
            }
        });

        this.addEventListener("keydown", event => {
            if (event.key === "Enter") {
                event.preventDefault();
                this.navigate();
            }
        });
    }

    private navigate(): void {
        if (this.target === "_blank") {
            this.navigateNewWindow();
        } else {
            this.navigateSameWindow();
        }
    }

    private navigateNewWindow(): void {
        this.nav.redirectNewWindow(this.href);
    }

    private navigateSameWindow(): void {
        this.nav.redirect(this.href);
    }
}